import React from 'react';

import WizardForm from '../wizardform/WizardForm';
import ZoneInfoForm from './zoneinfoform/ZoneInfoForm';
import ZonePreview from './zonepreview/ZonePreview';

export const AddZoneForm = props => {
  return (
    <WizardForm
      onSubmit={props.onSubmit}
      steps={[ZoneInfoForm, ZonePreview]}
      props={{
        sites: props.sites,
        areas: props.areas,
        onSiteSelect: props.onSiteSelect,
        onAreaSelect: props.onAreaSelect
      }}
    />
  );
};


export default AddZoneForm;



// WEBPACK FOOTER //
// ./src/components/forms/addzoneform/AddZoneForm.js